import { fetchAuthSession } from "aws-amplify/auth";
import { getSelectedAccountId } from "../../shared/lib/auth/accountContext";
import { getCachedUserAttributes } from "./authSessionAttributes";
import { isEmailRecentlyConfirmed } from "./emailVerificationOverride";

function toBoolean(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (value == null) return fallback;
  return String(value).toLowerCase() === "true";
}

function buildUserFromTokenPayload(payload, attributes) {
  const email = attributes?.email || payload.email || null;
  const selectedAccountId = getSelectedAccountId(email);
  const accountsCount = Number(payload["custom:accounts_count"] || 0);
  const isProfileComplete = toBoolean(
    attributes?.["custom:complete_profile"],
    toBoolean(payload["custom:complete_profile"])
  );
  const tokenRequiresAccountSelection = toBoolean(
    payload["custom:account_selection_required"]
  );
  const accountId = selectedAccountId || null;
  const accountSelectionRequired = !accountId && tokenRequiresAccountSelection;

  return {
    id: payload.sub,
    username: payload["cognito:username"],
    email,
    emailVerified: toBoolean(
      attributes?.email_verified,
      toBoolean(payload.email_verified)
    ) || isEmailRecentlyConfirmed(email),
    completeProfile: isProfileComplete,
    name: attributes?.name || payload.name || null,
    picture: payload.picture || null,
    accountId,
    accountSelectionRequired,
    accountsCount,
  };
}

export async function getAuthSessionUser({ forceRefresh = false } = {}) {
  const session = await fetchAuthSession({ forceRefresh });
  const idToken = session?.tokens?.idToken;

  if (!idToken) return null;

  let attributes = null;

  try {
    attributes = await getCachedUserAttributes();
  } catch {
    attributes = null;
  }

  return buildUserFromTokenPayload(idToken.payload, attributes);
}
